export default {
  'channelReseller.title': 'Revendedores',
  'channelReseller.description':
    'Registra entidades revendedor con padre distribuidor o partner opcional.',

  'channelReseller.columns.billingResponsibility': 'Responsabilidad de billing',

  'resellerBillingResponsibility.customerPaysAutomyStripe': 'Cliente paga (Stripe Automy)',
  'resellerBillingResponsibility.resellerPaysAutomy': 'Revendedor paga a Automy',
  'resellerBillingResponsibility.manual': 'Manual',
};
